/*

Language Service. 

*/

import 'whatwg-fetch'; /* global fetch */
import { API_URI } from './config';
import { find } from 'lodash';

export let languages = [];
let localizations = [];
export let selectedLocalization = 'en';


export function selectLanguage({code}) {
  selectedLocalization = code;
}

export function currentLanguage() {
  return selectedLocalization;
}

export default function lang(key) {
  const localization = find(localizations, l => l.key === key || l.value === key);
  if(!localization) {
    return "";
  }
  return localization[`value_${selectedLocalization}`] || localization['value'];
}

function loadLanguages() {
  return fetch(`${API_URI}/languages`)
    .then(res => res.json())
    .then(res => {
      languages = res;
      console.log('loaded languages');
    })
    .catch(err => console.error('Languages Error', err));
}

function loadLocalizations() {
  return fetch(`${API_URI}/localizations`)
    .then(res => res.json())
    .then(res => {
      localizations = res;
      console.log('loaded localizations', localizations);
    })
    .catch(err => console.error('Localizations Error', err));
}

export function load() {
  const loaders = [
    loadLocalizations(),
    loadLanguages()
  ];
  return Promise.all(loaders);
}


// WEBPACK FOOTER //
// ./src/services/lang.js